import { z } from 'zod';

export const placeItemSchema = z.object({
  // Yandex Geosuggest object URI (`ymapsbm1://…`). Used as a stable id AND as
  // the token passed to /api/places/resolve to fetch coordinates on pick.
  // (Was the 2GIS item id before the Yandex migration.)
  external_id: z.string(),
  name: z.string(),
  address: z.string().nullable(),
  // Geosuggest returns NO coordinates — lat/lng are resolved lazily via the
  // Yandex Geocoder (/api/places/resolve) only when the user picks an item,
  // so they are null on a suggestion. (Were always-present numbers under 2GIS.)
  lat: z.number().nullable(),
  lng: z.number().nullable(),
  distance_meters: z.number(),
  rubrics: z.array(z.string()),
});

export type PlaceItem = z.infer<typeof placeItemSchema>;

export const placeSearchInputSchema = z.object({
  q: z.string().min(3).max(100),
  lat: z.number().min(-90).max(90),
  lng: z.number().min(-180).max(180),
  limit: z.number().int().min(1).max(10).optional(),
});

export type PlaceSearchInput = z.infer<typeof placeSearchInputSchema>;

export const placeSearchResponseSchema = z.object({
  items: z.array(placeItemSchema),
});

export type PlaceSearchResponse = z.infer<typeof placeSearchResponseSchema>;

// Resolve a picked suggestion's URI → coordinates (Yandex Geocoder by uri).
export const placeResolveInputSchema = z.object({
  uri: z.string().min(1).max(2000),
});

export type PlaceResolveInput = z.infer<typeof placeResolveInputSchema>;

export const placeResolveResponseSchema = z.object({
  lat: z.number(),
  lng: z.number(),
});

export type PlaceResolveResponse = z.infer<typeof placeResolveResponseSchema>;
